@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId">{{ resolvedLabel() }}</label>
  <lib-postal-code-input
    [error]="showError"
    [controlId]="inputId"
    [formControl]="inputFormControl()"
    [countryType]="countryType() ?? CountryHelper.defaultCountry"
    [placeholder]="resolvedPlaceholder()">
  </lib-postal-code-input>
  @if (hintText()) {
    <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
      {{ hintText() }}
    </div>
  }
  @if (showError && !(inputFormControl().errors?.['no-error-message'] === true)) {
    <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
  }
</div>

